import React  from 'react'
import {localestr} from '../utils'


function ArrayForm({Text,caption,setModal,actions,id}){
    if(!actions) actions=[]
    const btn=actions.map((el,idx)=>{return(
        <div key={idx} style={{width:'auto',maxWidth:'100%',verticalAlign:'bottom',fontWeight:'normal'}} className={'key_btn'} onClick={()=>{setModal('');el.action()}}><div style={{minHeight:'30px',whiteSpace:'pre-wrap',padding:'0 5px'}}>{el.caption}</div></div>
    )})

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    function dragMouseDown(e) {
        e = e || window.event;
        // get the mouse cursor position at startup:
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.onmouseup = closeDragElement;
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag;
      }
    
      function elementDrag(e) {
        const elmnt=document.getElementById('modalWnd'+id)
        e = e || window.event;
        // calculate the new cursor position:
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        // set the element's new position:
        if (pos2!==0) elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
        if (pos1!==0) elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
      }
    
      function closeDragElement() {
        /* stop moving when mouse button is released:*/
        document.onmouseup = null;
        document.onmousemove = null;
      }

    return(
        <div className='modal'>
            <div id={'modalWnd'+id} className='window'>
                <div className='no-print' onMouseDown={dragMouseDown} style={{flexDirection:'row',display:'flex',justifyContent:'flex-start'}}><div className='caption'>{caption||localestr('Повідомлення')}</div><div className='closebtn' onClick={()=>{setModal('')}}/></div>
                <div className='content'>
                <div style={{margin:'0',display:'flex',justifyContent:'center',whiteSpace:'pre-wrap',fontWeight:'bold'}}>
                    {Text}
                </div>
                <div style={{margin:'4px 0 0 0',display:'flex',flexDirection:'column',justifyContent:'center'}}>
                    {btn}
                </div></div>
            </div>
        </div>
    )
}

export default ArrayForm